import {
  REFUND,
  REFUND_SUCCESS,
  REFUND_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false
};

const refundReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REFUND:
      return { ...state, loading: true };
    case REFUND_SUCCESS:
      return {
        ...state,
        reports: action?.payload,
        loading: false,
      };
    case REFUND_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default refundReducer;
